import { z } from "zod";
import { GeoPoint } from "firebase/firestore";

export const PostalAddressSchema = z.object({
  type: z.optional(z.literal("PostalAddress")),
  street: z.optional(z.string()).transform((val) => val ?? ""),
  postalCode: z.optional(z.string()).transform((val) => val ?? ""),
  city: z.optional(z.string()).transform((val) => val ?? ""),
  geoCoordinates: z.optional(
    z.preprocess(
      (val) => (val instanceof GeoPoint ? { lat: val.latitude, lng: val.longitude } : val),
      z.object({ lat: z.number(), lng: z.number() }),
    ),
  ),
});
export type PostalAddress = z.infer<typeof PostalAddressSchema>;

export function isPostalAddress(value: any): value is PostalAddress {
  return !!(
    value &&
    typeof value === "object" &&
    typeof value.street === "string" &&
    typeof value.postalCode === "string" &&
    typeof value.city === "string"
  );
}
